export default __webpack_public_path__ + "e6c21051b67f0ffcc2deeffd1a325d95.svg";